import React from 'react';
import { DetailPanelProps } from './types';
import { styles } from './styles';
import { ActionMenu, Button, LoadingBlock } from '@v2/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle, faRedo } from '@fortawesome/free-solid-svg-icons';

const DetailPanel: React.FC<DetailPanelProps> = ({
  title,
  subtitle,
  onClose,
  actions,
  loading = false,
  loadingMessage = 'Loading...',
  error,
  errorMessage = 'There was an error loading the details.',
  onRetry,
  children,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleGroup}>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && (
            <span className={styles.subtitle}>{subtitle}</span>
          )}
        </div>
        <div className={styles.headerActions}>
          {actions && actions.length > 0 && (
            <ActionMenu items={actions} ariaLabel="Panel actions" />
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            aria-label="Close panel"
            icon={<FontAwesomeIcon icon={faTimes} className={styles.closeIcon} />}
          />
        </div>
      </div>

      <div className={styles.content}>
        {loading && (
          <LoadingBlock label={loadingMessage} className={styles.stateContainer} />
        )}

        {!loading && error && (
          <div className={styles.stateContainer}>
            <FontAwesomeIcon
              icon={faExclamationCircle}
              className="tw-text-4xl tw-text-red-400 tw-mb-3"
            />
            <p className={styles.stateMessage}>{errorMessage}</p>
            {onRetry && (
              <Button
                variant="outline"
                size="sm"
                onClick={onRetry}
                icon={<FontAwesomeIcon icon={faRedo} />}
              >
                Retry
              </Button>
            )}
          </div>
        )}

        {!loading && !error && children}
      </div>
    </div>
  );
};

export default DetailPanel;
export type { DetailPanelProps } from './types';
